<script>
    // import { success_stories } from "../store";
    import {playAnimation} from '../store';
    import Navbar from '../navbar/navbar.svelte';
    const succesStories = [
        {
            'photo_path': '/images/success_stories_slider/borja-martelok.jpeg',
            'fullname': 'Borja Martel',
            'title': 'Co Founder | Lemon Cash',
            'small_description': 'Shaping the <mark class="marker"> future </mark>of crypto in Latin America',
        },
        {
            'photo_path': '/images/success_stories_slider/thomas_brag.png',
            'fullname': 'Thomas Brag',
            'title': 'Creator | Yes Theory',
            'small_description': 'Ove<mark class="marker">r 9 Billion </mark>views on Youtube',
        },
        {
            'photo_path': '/images/success_stories_slider/marame_dieng.png',
            'fullname': 'Marame Dieng',
            'title': 'Global Lead',
            'small_description': 'Global Innovation & Strateg<mark class="marker">y at 500</mark>',
        },
        {
            'photo_path': '/images/success_stories_slider/brian_friedman.png',
            'fullname': 'Brian Friedman',
            'title': 'Loopd',
            'small_description': 'Acquired by<mark class="marker"> Aventri</mark>',
        },
        {
            'photo_path': '/images/success_stories_slider/surbhi_sarna.png',
            'fullname': 'Surbhi Sarna',
            'title': 'Global Partner | Y Combinator',
            'small_description': 'nVision Medical cquired by Boston ' +
            '<br>Scientific fo<mark class="marker">r $275M</mark>',
        },
        {
            'photo_path': '/images/success_stories_slider/artak_melkonyan.png',
            'fullname': 'Artak Melkonyan',
            'title': 'Global Lead | UNDP Impact ',
            'small_description': 'UN<mark class="marker">DP x Drap</mark>erU healthcare accelerator.',
        },

        {
            'photo_path': '/images/success_stories_slider/madeline_callander.png',
            'fullname': 'Madeline Callander',
            'title': 'Boost VC ',
            'small_description': 'V<mark class="marker">ice Presid</mark>ent Accelerator & Portfolio',
        },
        {
            'photo_path': '/images/success_stories_slider/ian_proulx.png',
            'fullname': 'Ian Proulx',
            'title': 'CEO | 147 Games',
            'small_description': 'Raised <mark class="marker">$100 M in</mark> 2021',
        },
        {
            'photo_path': '/images/success_stories_slider/denny_liu.png',
            'fullname': 'Denny Liu',
            'title': 'Le Pur',
            'small_description': 'Valued at over<mark class="marker"> $100 M i</mark>n '+
            '<br> partnership with Coca Cola',
        },
        {
            'photo_path': '/images/success_stories_slider/konstantin_masslenikov.png',
            'fullname': 'Konstantin Masslenikov',
            'title': 'TakeBus',
            'small_description': '<mark class="marker">Acquire</mark>d by Russia’s ' +
            '<br> largest transportation company',
        },
        {
            'photo_path': '/images/success_stories_slider/autumn_penaloza.png',
            'fullname': 'Autumn Penaloza',
            'title': 'Head of Community | Algorand',
            'small_description': 'p<mark class="marker">artner for</mark> blockchain accelaration',
        },
        {
            'photo_path': '/images/success_stories_slider/guillame_rolland.png',
            'fullname': 'Guillame Rolland',
            'title': 'Sensorwake',
            'small_description': 'Acquired <mark class="marker">by Google</mark>',
        },
    ];
    let slider;
    let sideMenu;
    let sideMenuInner;
    let menu = '';
    let arrowdown;
    let arrowdown2;
    let arrowdown3;
    let arrowdown4;
    let cur = 0;
    $: console.log(cur);
    let sliderClass = 'start';
    $: console.log('sliderClass', sliderClass);
</script>
<div class="d-flex light_animate justify-content-between">
    <div class="img-wrraper {$playAnimation ? '' : 'lighting-animation'}">
        <img src="/images/header/light.svg" alt="" width="100%" />
    </div>
    <div class="img-wrraper {$playAnimation ? '' : 'lighting-animation'}">
        <img src="/images/header/light2.svg" alt="" width="100%" />
    </div>
</div>
<section>
    <div class="container-fluid">
        <div class="row">
            <div class="desktop" style="margin-bottom: 10vw;">
                <Navbar />
            </div>
            <!--Mobile Version--->
            <div class="mobile">
                <div class="main-div">
                    <div
                        class="logo-img"
                        on:click={() => {
                            location.href = '/';
                        }}
                    >
                        <img
                            src="/images/header/draper_logo.svg"
                            alt=" "
                            width="100%"
                        />
                    </div>
                    <div
                        class="menu-icon"
                        on:click={() => {
                            sideMenu.style.left = '0';
                            sideMenu.style.transitionDuration = '1s';
                            sideMenuInner.style.left = '33vw';
                            sideMenuInner.style.transitionDuration = '1s';
                        }}
                    >
                        <img
                            src="images/navbar/menubar.svg"
                            alt=""
                            width="100%"
                        />
                    </div>
                </div>
                <div
                    class="menu-back-style"
                    bind:this={sideMenu}
                    on:click={() => {
                        sideMenu.style.left = '100vw';
                        sideMenu.style.transitionDuration = '1s';
                        sideMenu.style.top = '0vw';
                        sideMenuInner.style.left = '100vw';
                        sideMenuInner.style.transitionDuration = '1s';
                        sideMenuInner.style.top = '0vw';
                    }}
                />
                <div class="menu-section" bind:this={sideMenuInner}>
                    <div class="logo-sidebar">
                        <img
                            src="/images/header/draper_logo.svg"
                            alt=" "
                            width="100%"
                        />
                    </div>
                    <div class="hr-css">
                        <hr class="hr" />
                    </div>
                    <div class="list">
                        <ul style="padding-left:5vw;height: 70vh;overflow-y: scroll;padding-bottom: 10vh;">
                            <li>
                                <div
                                    class="head-mbl "
                                    on:click={() => {
                                        if (
                                            menu === '' ||
                                            menu === 'government' ||
                                            menu === 'executives' ||
                                            (menu === 'investors' &&
                                                arrowdown.style.transform ===
                                                    'rotate(0deg)') ||
                                            arrowdown2.style.transform ===
                                                'rotate(180deg)' ||
                                            arrowdown3.style.transform ===
                                                'rotate(180deg)' ||
                                            arrowdown4.style.transform ===
                                                'rotate(180deg)'
                                        ) {
                                            menu = 'founder';
                                            arrowdown.style.transform =
                                                'rotate(180deg)';
                                            arrowdown2.style.transform =
                                                'rotate(0deg)';
                                            arrowdown3.style.transform =
                                                'rotate(0deg)';
                                            arrowdown4.style.transform =
                                                'rotate(0deg)';
                                        } else {
                                            menu = '';
                                            arrowdown.style.transform =
                                                'rotate(0deg)';
                                        }
                                    }}
                                >
                                    <div
                                        class="arrowdown"
                                        bind:this={arrowdown}
                                    >
                                        <img
                                            src="/images/arrowDown.svg"
                                            alt=""
                                            width="100%"
                                        />
                                    </div>
                                    <div class="head-logo">
                                        <img
                                            src="images/navbar/founder.svg"
                                            alt=""
                                            width="100%"
                                        />
                                    </div>
                                    <div>
                                        <h5 class="h-clr">Founders</h5>
                                    </div>
                                </div>
                                {#if menu === 'founder'}
                                    <div class="menuHolder">
                                        <div
                                            style="display: flex;
                                            padding-left: 4vw;
                                            justify-content: space-evenly;"
                                            on:click={() => {
                                                location.href =
                                                    '/program_fundamental';
                                            }}
                                        >
                                            <div>
                                                <h6
                                                    style="margin: 4vw 0;font-size:3.738vw;color: #3C74C0;"
                                                >
                                                    1-
                                                </h6>
                                            </div>
                                            <div style="width:70%;">
                                                <h6
                                                    style="margin: 4vw 0; font-size:3.738vw;color: #3C74C0;"
                                                >
                                                    Fundamental of
                                                    Entrepreneurship
                                                </h6>
                                                <h6
                                                    style="margin: 4vw 0; font-size: 3vw;display:flex;align-items:center;"
                                                >
                                                    <div
                                                        style="height:2vw;width:2vw;background-color:#82ace5;border-radius: 50vw;margin-right: 4vw;"
                                                    />
                                                    virtual -2 weeks
                                                </h6>
                                                <h6
                                                    style="margin: 4vw 0;font-size: 2.6vw;"
                                                >
                                                    Learning and networking with
                                                    over 50 Silicon Valley
                                                    experts, mentors and global
                                                    entrepreneurs.
                                                </h6>
                                            </div>
                                        </div>
                                        <hr
                                            style="color: rgb(130, 172, 229);margin:0;"
                                        />
                                        <div
                                            style="display: flex;
                                            padding-left: 4vw;
                                            justify-content: space-evenly;"
                                            on:click={() => {
                                                location.href = '/program_hero';
                                            }}
                                        >
                                            <div>
                                                <h6
                                                    style="margin: 4vw 0;font-size:3.738vw;color: #3C74C0;"
                                                >
                                                    2-
                                                </h6>
                                            </div>
                                            <div style="width:70%;">
                                                <h6
                                                    style="margin: 4vw 0; font-size:3.738vw;color: #3C74C0;"
                                                >
                                                    Hero Training
                                                </h6>
                                                <h6
                                                    style="margin: 4vw 0; font-size: 3vw;display:flex;align-items:center;"
                                                >
                                                    <div
                                                        style="height:2vw;width:2vw;background-color:#82ace5;border-radius: 50vw;margin-right: 4vw;"
                                                    />
                                                    5 Weeks - Silicon Valley
                                                </h6>
                                                <h6
                                                    style="margin: 4vw 0;font-size: 2.6vw;"
                                                >
                                                    An intensive, immersive
                                                    five-week pre-accelerator
                                                    program in Silicon Valley,
                                                    CA.
                                                </h6>
                                            </div>
                                        </div>
                                        <hr
                                            style="color: rgb(130, 172, 229);margin:0;"
                                        />
                                        <div
                                            style="display: flex;
                                            padding-left: 4vw;
                                            justify-content: space-evenly;"
                                            on:click={() => {
                                                location.href =
                                                    '/houseCeek';
                                            }}
                                        >
                                            <div>
                                                <h6
                                                    style="margin: 4vw 0;font-size:3.738vw;color: #3C74C0;"
                                                >
                                                    3-
                                                </h6>
                                            </div>
                                            <div style="width:70%;">
                                                <h6
                                                    style="margin: 4vw 0; font-size:3.738vw;color: #3C74C0;"
                                                >
                                                    House of Ceek
                                                </h6>
                                                <h6
                                                    style="margin: 4vw 0; font-size: 3vw;display:flex;align-items:center;"
                                                >
                                                    <div
                                                        style="height:2vw;width:2vw;background-color:#82ace5;border-radius: 50vw;margin-right: 4vw;"
                                                    />
                                                    virtual -2 weeks
                                                </h6>
                                                <h6
                                                    style="margin: 4vw 0;font-size: 2.6vw;"
                                                >
                                                A fully sponsored program for VR Builders & Game Developers to create groundbreaking assets for the CEEK metaverse. 
                                                </h6>
                                            </div>
                                        </div>
                                        <hr
                                            style="color: rgb(130, 172, 229);margin:0;"
                                        />
                                        <div
                                            style="display: flex;
                                            padding-left: 4vw;
                                            justify-content: space-evenly;"
                                            on:click={() => {
                                                location.href =
                                                    '/kanoopage';
                                            }}
                                        >
                                            <div>
                                                <h6
                                                    style="margin: 4vw 0;font-size:3.738vw;color: #3C74C0;"
                                                >
                                                    4-
                                                </h6>
                                            </div>
                                            <div style="width:70%;">
                                                <h6
                                                    style="margin: 4vw 0; font-size:3.738vw;color: #3C74C0;"
                                                >
                                                    Kanoo Innovation Hub
                                                </h6>
                                                <h6
                                                    style="margin: 4vw 0; font-size: 3vw;display:flex;align-items:center;"
                                                >
                                                    <div
                                                        style="height:2vw;width:2vw;background-color:#82ace5;border-radius: 50vw;margin-right: 4vw;"
                                                    />
                                                    virtual -2 weeks
                                                </h6>
                                                <h6
                                                    style="margin: 4vw 0;font-size: 2.6vw;"
                                                >
                                                We are developing and investing in the most powerful startups in the Caribbean along with Kanoo Innovation Hub. Join today! 
                                                </h6>
                                            </div>
                                        </div>
                                        <hr
                                            style="color: rgb(130, 172, 229);margin:0;"
                                        />
                                    </div>
                                {/if}
                            </li>

                            <li>
                                <div
                                    class="head-mbl"
                                    on:click={() => {
                                        if (
                                            menu === 'founder' ||
                                            menu === 'government' ||
                                            menu === '' ||
                                            (menu === 'investors' &&
                                                arrowdown2.style.transform ===
                                                    'rotate(0deg)') ||
                                            arrowdown.style.transform ===
                                                'rotate(180deg)' ||
                                            arrowdown3.style.transform ===
                                                'rotate(180deg)' ||
                                            arrowdown4.style.transform ===
                                                'rotate(180deg)'
                                        ) {
                                            menu = 'executives';
                                            arrowdown2.style.transform =
                                                'rotate(180deg)';
                                            arrowdown3.style.transform =
                                                'rotate(0deg)';
                                            arrowdown4.style.transform =
                                                'rotate(0deg)';
                                            arrowdown.style.transform =
                                                'rotate(0deg)';
                                        } else {
                                            menu = '';
                                            arrowdown2.style.transform =
                                                'rotate(0deg)';
                                        }
                                    }}
                                >
                                    <div
                                        class="arrowdown"
                                        bind:this={arrowdown2}
                                    >
                                        <img
                                            src="/images/arrowDown.svg"
                                            alt=""
                                            width="100%"
                                        />
                                    </div>
                                    <div class="head-logo">
                                        <img
                                            src="images/navbar/excute.svg"
                                            alt=""
                                            width="100%"
                                        />
                                    </div>
                                    <div>
                                        <h5 class="h-clr">Executives</h5>
                                    </div>
                                </div>
                                {#if menu === 'executives'}
                                    <div class="menuHolder">
                                        <div
                                            style="display: flex;
                                    padding-left: 4vw;
                                    justify-content: space-evenly;"
                                            on:click={() => {
                                                location.href =
                                                    '/program_coporative';
                                            }}
                                        >
                                            <div>
                                                <h6
                                                    style="margin: 4vw 0;font-size:3.738vw;color: #3C74C0;"
                                                >
                                                    1-
                                                </h6>
                                            </div>
                                            <div style="width:70%;">
                                                <h6
                                                    style="margin: 4vw 0; font-size:3.738vw;color: #3C74C0;"
                                                >
                                                    Corporate Innovation Program
                                                </h6>
                                                <h6
                                                    style="margin: 4vw 0; font-size: 3vw;display:flex;align-items:center;"
                                                >
                                                    <div
                                                        style="height:2vw;width:2vw;background-color:#82ace5;border-radius: 50vw;margin-right: 4vw;"
                                                    />
                                                    5 Week - Hybrid
                                                </h6>
                                                <h6
                                                    style="margin: 4vw 0;font-size: 2.6vw;"
                                                >
                                                    Gain necessary knowledge,
                                                    experience, and leadership
                                                    skills to bringinnovation
                                                    back to your company and
                                                    team.
                                                </h6>
                                            </div>
                                        </div>
                                        <hr
                                            style="color: rgb(130, 172, 229);margin:0;"
                                        />
                                        <div
                                            style="display: flex;
                                    padding-left: 4vw;
                                    justify-content: space-evenly;"
                                            on:click={() => {
                                                location.href =
                                                    '/program_coporative_accelerator';
                                            }}
                                        >
                                            <div>
                                                <h6
                                                    style="margin: 4vw 0;font-size:3.738vw;color: #3C74C0;"
                                                >
                                                    2-
                                                </h6>
                                            </div>
                                            <div style="width:70%;">
                                                <h6
                                                    style="margin: 4vw 0; font-size:3.738vw;color: #3C74C0;"
                                                >
                                                    Corporate Accelerators
                                                </h6>
                                                <h6
                                                    style="margin: 4vw 0; font-size: 3vw;display:flex;align-items:center;"
                                                >
                                                    <div
                                                        style="height:2vw;width:2vw;background-color:#82ace5;border-radius: 50vw;margin-right: 4vw;"
                                                    />
                                                    10 Weeks - Hybrid
                                                </h6>
                                                <h6
                                                    style="margin: 4vw 0;font-size: 2.6vw;"
                                                >
                                                    Future-proof your business
                                                    by investing and building
                                                    with the most exciting
                                                    startups in your industry.
                                                </h6>
                                            </div>
                                        </div>
                                        <hr
                                            style="color: rgb(130, 172, 229);margin:0;"
                                        />
                                        <div
                                            style="display: flex;
                                padding-left: 4vw;
                                justify-content: space-evenly;"
                                            on:click={() => {
                                                location.href =
                                                    '/program_blockchain';
                                            }}
                                        >
                                            <div>
                                                <h6
                                                    style="margin: 4vw 0;font-size:3.738vw;color: #3C74C0;"
                                                >
                                                    3-
                                                </h6>
                                            </div>
                                            <div style="width:70%;">
                                                <h6
                                                    style="margin: 4vw 0; font-size:3.738vw;color: #3C74C0;"
                                                >
                                                    Blockchain Accelerators
                                                </h6>
                                                <h6
                                                    style="margin: 4vw 0; font-size: 3vw;display:flex;align-items:center;"
                                                >
                                                    <div
                                                        style="height:2vw;width:2vw;background-color:#82ace5;border-radius: 50vw;margin-right: 4vw;"
                                                    />
                                                    10 Weeks - Hybrid
                                                </h6>
                                                <h6
                                                    style="margin: 4vw 0;font-size: 2.6vw;"
                                                >
                                                    Partner with us to
                                                    accelerate your blockchain
                                                    ecosystem with superhero
                                                    founders.
                                                </h6>
                                            </div>
                                        </div>
                                        <hr
                                            style="color: rgb(130, 172, 229);margin:0;"
                                        />
                                    </div>
                                {/if}
                            </li>

                            <li>
                                <div
                                    class="head-mbl"
                                    on:click={() => {
                                        if (
                                            menu === 'founder' ||
                                            menu === 'government' ||
                                            menu === 'executives' ||
                                            (menu === '' &&
                                                arrowdown3.style.transform ===
                                                    'rotate(0deg)') ||
                                            arrowdown2.style.transform ===
                                                'rotate(180deg)' ||
                                            arrowdown.style.transform ===
                                                'rotate(180deg)' ||
                                            arrowdown4.style.transform ===
                                                'rotate(180deg)'
                                        ) {
                                            menu = 'investors';
                                            arrowdown3.style.transform =
                                                'rotate(180deg)';
                                            arrowdown4.style.transform =
                                                'rotate(0deg)';
                                            arrowdown2.style.transform =
                                                'rotate(0deg)';
                                            arrowdown.style.transform =
                                                'rotate(0deg)';
                                        } else {
                                            menu = '';
                                            arrowdown3.style.transform =
                                                'rotate(0deg)';
                                        }
                                    }}
                                >
                                    <div
                                        class="arrowdown"
                                        bind:this={arrowdown3}
                                    >
                                        <img
                                            src="/images/arrowDown.svg"
                                            alt=""
                                            width="100%"
                                        />
                                    </div>
                                    <div class="head-logo">
                                        <img
                                            src="images/navbar/invest.svg"
                                            alt=""
                                            width="100%"
                                        />
                                    </div>
                                    <div>
                                        <h5 class="h-clr">Investors</h5>
                                    </div>
                                </div>
                                {#if menu === 'investors'}
                                    <div class="menuHolder">
                                        <div
                                            style="display: flex;
                                    padding-left: 4vw;
                                    justify-content: space-evenly;"
                                            on:click={() => {
                                                location.href = '/program_vcx';
                                            }}
                                        >
                                            <div>
                                                <h6
                                                    style="margin: 4vw 0;font-size:3.738vw;color: #3C74C0;"
                                                >
                                                    1-
                                                </h6>
                                            </div>
                                            <div style="width:70%;">
                                                <h6
                                                    style="margin: 4vw 0; font-size:3.738vw;color: #3C74C0;"
                                                >
                                                    VcX
                                                </h6>
                                                <h6
                                                    style="margin: 4vw 0; font-size: 3vw;display:flex;align-items:center;"
                                                >
                                                    <h6
                                                        style="margin: 4vw 0;font-size: 2.6vw;"
                                                    >
                                                        Where new generations of
                                                        entrepreneurial families
                                                        around the world
                                                        buildand network with
                                                        top Silicon Valley VCs
                                                        and founders leading the
                                                        future.
                                                    </h6>
                                                </h6>
                                            </div>
                                        </div>
                                        <hr
                                            style="color: rgb(130, 172, 229);margin:0;"
                                        />
                                        <div
                                            style="display: flex;
                                    padding-left: 4vw;
                                    justify-content: space-evenly;"
                                            on:click={() => {
                                                location.href =
                                                    '/program_invest';
                                            }}
                                        >
                                            <div>
                                                <h6
                                                    style="margin: 4vw 0;font-size:3.738vw;color: #3C74C0;"
                                                >
                                                    2-
                                                </h6>
                                            </div>
                                            <div style="width:70%;">
                                                <h6
                                                    style="margin: 4vw 0; font-size:3.738vw;color: #3C74C0;"
                                                >
                                                    Invest with us
                                                </h6>
                                                <h6
                                                    style="margin: 4vw 0;font-size: 2.6vw;"
                                                >
                                                    We invest in founders
                                                    building the future. If you
                                                    want to get involved with
                                                    pre-seed to pre-series A
                                                    companies, join our investor
                                                    network!
                                                </h6>
                                            </div>
                                        </div>
                                        <hr
                                            style="color: rgb(130, 172, 229);margin:0;"
                                        />
                                    </div>
                                {/if}
                            </li>

                            <li>
                                <div
                                    class="head-mbl"
                                    on:click={() => {
                                        if (
                                            menu === 'founder' ||
                                            menu === '' ||
                                            menu === 'executives' ||
                                            (menu === 'investors' &&
                                                arrowdown4.style.transform ===
                                                    'rotate(0deg)') ||
                                            arrowdown2.style.transform ===
                                                'rotate(180deg)' ||
                                            arrowdown.style.transform ===
                                                'rotate(180deg)' ||
                                            arrowdown3.style.transform ===
                                                'rotate(180deg)'
                                        ) {
                                            menu = 'government';
                                            arrowdown4.style.transform =
                                                'rotate(180deg)';
                                            arrowdown3.style.transform =
                                                'rotate(0deg)';
                                            arrowdown2.style.transform =
                                                'rotate(0deg)';
                                            arrowdown.style.transform =
                                                'rotate(0deg)';
                                        } else {
                                            menu = '';
                                            arrowdown4.style.transform =
                                                'rotate(0deg)';
                                        }
                                    }}
                                >
                                    <div
                                        class="arrowdown"
                                        bind:this={arrowdown4}
                                    >
                                        <img
                                            src="/images/arrowDown.svg"
                                            alt=""
                                            width="100%"
                                        />
                                    </div>
                                    <div class="head-logo">
                                        <img
                                            src="images/navbar/govt.svg"
                                            alt=""
                                            width="100%"
                                        />
                                    </div>
                                    <div>
                                        <h5 class="h-clr">Government</h5>
                                    </div>
                                </div>
                                {#if menu === 'government'}
                                    <div class="menuHolder">
                                        <div
                                            style="display: flex;
                                            padding-left: 4vw;
                                            justify-content: space-evenly;"
                                            on:click={() => {
                                                location.href =
                                                    '/program_global';
                                            }}
                                        >
                                            <div>
                                                <h6
                                                    style="margin: 4vw 0;font-size:3.738vw;color: #3C74C0;"
                                                >
                                                    1-
                                                </h6>
                                            </div>
                                            <div style="width:70%;">
                                                <h6
                                                    style="margin: 4vw 0; font-size:3.738vw;color: #3C74C0;"
                                                >
                                                    Global Government
                                                    Partnership
                                                </h6>
                                                <h6
                                                    style="margin: 4vw 0;font-size: 2.6vw;"
                                                >
                                                    Where new generations of
                                                    entrepreneurial families
                                                    around the world build and
                                                    network with top Silicon
                                                    Valley VCs and founders
                                                    leading the future.
                                                </h6>
                                            </div>
                                        </div>
                                        <hr
                                            style="color: rgb(130, 172, 229);margin:0;"
                                        />
                                    </div>
                                {/if}
                            </li>
                        </ul>
                    </div>
                   <div style="display: flex; justify-content: center;">
                <button class="btn-mbl-sidebar" on:click={() => (location.href = 'alumni')}>Alumni Success Stories</button>
                <div style="font-size: 3.271vw;
                color: #3c74c0;
                position: absolute;
                bottom: 5.841vw;" 
                on:click={()=>{
                    location.href = '/contact_us';
              }}>Contact Us</div>
            </div>
                </div>
            </div>
            <div class="desktop">
                <div class="col-md-12 col-xl-12" style="margin-top:4vw;">
                    <div class="head_text">
                        <h4
                            class="text-center fw-bold "
                            style="width: 55vw;margin:auto;"
                        >
                            Transforming individuals into superheroes, who
                            change the world.
                        </h4>
                    </div>
                    <h6 class="head_text2 text-center" style="margin-top:2vw;">
                        Build your startup, career and network with us!
                    </h6>
                </div>
            </div>
            <!--Mobile Design--->
            <div class="mobile">
                <div class="back-img ">
                    <div class="back-img-mbl-left">
                        <img
                            src="/images/header/light1.png"
                            alt=""
                            width="100%"
                        />
                    </div>
                    <div class="back-img-mbl-right">
                        <img
                            src="/images/header/light2.png"
                            alt=""
                            width="100%"
                        />
                    </div>
                </div>
                <div class="text">
                    <div class="head-text-mbl">
                        <h4>
                            Transforming individuals into superheroes, who
                            change the world.
                        </h4>
                    </div>
                    <div class="head-text2-mbl">
                        <h6>Build your startup, career and network with us!</h6>
                    </div>
                    <div class="btn-css">
                        <button
                            class="btn2-mbl"
                            on:click={() => {
                                location.href = '#programs_mob';
                            }}
                        >
                            Explore Opportunities
                        </button>
                    </div>
                </div>
            </div>
            <div class="desktop">
                <div
                    class="col-md-12 col-xl-12"
                    style="margin: 2vw 0 8vw 0; position:relative;z-index:0;"
                >
                    <div class="d-flex text-center justify-content-center">
                        <a
                            class="btn2"
                            style="text-decoration:none; margin-right:0.3685vw;"
                            href="#programs"
                        >
                            Explore Opportunities
                        </a>
                    </div>
                </div>
            </div>
            <!-- ------------------slider------------------ -->
            <!---Mobile Slider-->
            <div class="mobile">
                <div class="col-12">
                    <div>
                        <div class="row" style="margin: 0vw;">
                            <div class="col-12" style="padding: 0vw;">
                                <div class="slider-mbl">
                                    {#each succesStories as story}
                                        <div class="sli-mbl">
                                            <div class="img-warraper-mbl">
                                                <img
                                                    src={story.photo_path}
                                                    alt=""
                                                    width="100%"
                                                />
                                            </div>
                                            <div class="data-part-mbl">
                                                <p class="name-text">
                                                    {story.fullname}
                                                </p>
                                                <p class="">
                                                    {story.title}
                                                </p>
                                                <p>
                                                    {@html story.small_description}
                                                </p>
                                            </div>
                                        </div>
                                    {/each}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="successstories-mbl">
                    <div
                        style="width:2.336vw; height:2.336vw; background-color:#7CC1FF; border-radius:50%;margin-left: 23.131vw;"
                    />
                    <p
                        style="
                    width: 42.991vw;
                    font-size: 5.607vw;
                    color: rgb(0, 32, 75);
                    font-weight: 500;
                    margin-left: 28.505vw;
                    margin-top: -5.5vw;
                    "
                    >
                        Success Stories
                    </p>
                    <p
                        style="
                    width: 75vw;
                    font-size: 3.271vw;
                    color: rgba(0, 32, 75, 0.8);
                    margin-left: 12.383vw;
                    line-height: 3.958vw;
                    text-align: justify;
                    margin-top: 4.009vw;
                "
                    >
                        Top global talent comes to DraperU to connect, grow and
                        build. Whether it is starting new companies, joining
                        fast-growing startups, innovating corporate and
                        governments, or accelerating personal growth, our
                        superhero alums pursue life with gusto and enthusiasm.
                    </p>
                    <p
                        style="
                    width: 36.206vw;
                    font-size: 3.271vw;
                    text-align: center;
                    line-height: 3.687vw;
                    font-family: 'Share Tech';
                    color: rgba(0, 32, 75, 0.8);
                    margin-left: 32.280vw;
                    margin-top: 5.009vw;
                "
                    >
                        Created at the heart of Silicon Valley
                    </p>
                    <button
                        style="
                    text-decoration: none;
                    color: rgba(11, 75, 160, 1);
                    font-size: 3.32vw;
                    margin-left: 36.449vw;
                    border: none;
                    background-color: transparent;
                    margin-top: 5.009vw;
                "
                        on:click={() => {
                            location.href = '#programs_mob';
                        }}
                    >
                        Explore Programs</button
                    >
                    <hr
                        style="
                width: 22.136vw;
                border-radius: 0.369vw;
                color: rgba(247, 224, 95, 1);
                margin-left: 39.3vw;
                opacity: 85%;
                border: 0.2vw solid;
            "
                    />
                </div>
            </div>
            <div class="desktop">
                <div class="mb-5 col-md-12 col-xl-12" style="margin-top:-2vw;">
                    <div
                        style="width: 86%;position: relative;margin-left: auto;margin-right: auto;margin-bottom: 6.956vw;"
                    >
                        <div class="row">
                            <div class="col-xl-12 col-md-12">
                                <div
                                    class="d-flex justify-content-between slider overflow-auto"
                                    style="gap: 3.211vw;"
                                    bind:this={slider}
                                >
                                    {#each succesStories as story}
                                        <div
                                            style="width: 13.994vw;"
                                            class={sliderClass}
                                        >
                                            <div class="slider-img">
                                                <img
                                                    style="height: 100%; width:100% "
                                                    src={story.photo_path}
                                                    alt=""
                                                />
                                            </div>
                                            <div style="margin-top:1.198vw;">
                                                <div>
                                                    <p
                                                        style="font-size: 1.198vw; font-weight:500; color:#00204B; margin: 0;"
                                                    >
                                                        {story.fullname}
                                                    </p>
                                                </div>
                                                <div
                                                    style="margin-bottom: 0.4vw; height: 1vw;"
                                                >
                                                    <p
                                                        style="font-size: 0.671vw; font-weight:500; color:#00204B; margin: 0;"
                                                    >
                                                        {story.title}
                                                    </p>
                                                </div>
                                                <div>
                                                    <p
                                                        style="font-size: 0.671vw; font-weight:500; color:#00204B; margin: 0;"
                                                    >
                                                        {@html story.small_description}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    {/each}
                                </div>
                            </div>
                        </div>

                        {#if cur < 3310}
                            <div
                                style="position: absolute;top: 4vw;right: -4vw;"
                            >
                                <div
                                    style="width: 2.205vw; height: 1.992vw; cursor: pointer;"
                                    on:click={() => {
                                        cur += 1655;
                                        if (sliderClass == 'start-slider') {
                                            sliderClass = 'next-slider';
                                        } else {
                                            sliderClass = 'start-slider';
                                        }
                                    }}
                                >
                                    <img
                                        src="images/fundamental_programs/next_button.svg"
                                        alt=""
                                        width="100%"
                                    />
                                </div>
                            </div>
                        {/if}
                        <div
                            style="position: absolute;top: 4vw;left: -4vw; transform: rotate(180deg);"
                        >
                                {#if cur != 0}
                                    <div
                                        style="width: 2.205vw; height: 1.992vw; cursor: pointer;"
                                        on:click={() => {
                                            cur -= 1655;
                                            if (
                                                sliderClass == 'start-slider'
                                            ) {
                                                sliderClass = 'prev-slider';
                                            } else {
                                                sliderClass = 'start-slider';
                                            }
                                        }}
                                    >
                                        <img
                                            src="images/fundamental_programs/next_button.svg"
                                            alt=""
                                            width="100%"
                                        />
                                    </div>
                                {/if}
                        </div>
                        <!-- ------------------slider------------------ -->
                        <div class="desktop">
                            <div class="col-md-12 col-xl-12" style="margin-top: 7vw;">
                                <div class="row">
                                    <div
                                        class="d-flex justify-content-center col-md-6 col-xl-6"
                                    >
                                        <div class="circle me-4" />
                                        <h5
                                            class="fw-bold mb-0"
                                            style="font-size:2.067vw; color:rgba(0, 32, 75, 1);"
                                        >
                                            Success <br />
                                            Stories
                                        </h5>
                                    </div>
                                    <div class="col-md-6 col-xl-6">
                                        <div
                                            style="width: 33.135vw;
                                            font-size: 1.19vw;
                                            margin-left: -4.9vw;
                                            font-weight: 400;
                                            color: #00204B; ">
                                            <p class="mb-0">
                                                Top global talent comes to
                                                DraperU to connect, grow and
                                                build. Whether it is starting
                                                new companies, joining
                                                fast-growing startups,
                                                innovating corporate and
                                                governments, or accelerating
                                                personal growth, our superhero
                                                alums pursue life with gusto and
                                                enthusiasm.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 col-xl-12 my-5">
                                <div class="row">
                                    <div class="col-md-6 text-center col-xl-6">
                                        <p
                                            class="text-start"
                                            style="width: 13.714vw;
                                    margin: auto;
                                    font-size: 1.19vw;
                                    font-family: 'Share Tech';
                                    padding-left: 3vw;
                                    line-height: 1.349vw;
                                    color: rgba(0, 32, 75, 0.8);"
                                        >
                                            Created at the heart of Silicon
                                            Valley
                                        </p>
                                    </div>
                                    <div
                                        class="col-md-6 col-xl-6"
                                        style="position: relative;
                                z-index: 5;
                                margin-top: 0.5vw;
                                margin-left: -4.9vw;"
                                    >
                                        <a
                                            class="text-start mb-0"
                                            style="font-size: 1.19vw;
                                    color: rgba(11, 75, 160, 1);
                                    text-decoration: none;"
                                            href="#programs"
                                        >
                                            Explore Programs
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="desktop">
                        <hr
                            style="width: 90vw;margin:2vw auto;height: 0.1vw;color:#C4C4C480;opacity:1;"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    .menuHolder {
        position: relative;
    }
    .arrowdown {
        width: 7vw;
        transform: rotate(0deg);
    }
    .slider-div {
        transition: transform 5s, opacity 2s;
    }
    .start-slider {
        transform: translate(-85vw);
        transition-duration: 1s;
        opacity: 1;
    }
    .next-slider {
        transform: translate(-120vw);
        transition-duration: 1s;
        opacity: 1;
    }
    .prev-slider {
        transform: translate(0vw);
        transition-duration: 1s;
        opacity: 1;
    }
    .animation-container {
        z-index: 11;
        position: absolute;
        height: 100%;
        width: 100%;
    }
    .animation-background {
        height: 100vh;
        width: 100%;
        position: absolute;
        z-index: 10;
    }
    .animation-background.white {
        background-color: white;
    }
    .animation-background.blue {
        background-color: #175a9e;
    }
    .sli {
        padding: 1.5vw 0.5vw;
        border-radius: 1vw;
    }
    .sli:hover {
        background: #e2f2ff;
        border-radius: 1vw;
    }
    .light_animate {
        position: absolute;
        width: 100%;
        margin-top: 0;
        animation-name: light;
        animation-duration: 0.5s;
        animation-delay: 0s;
        animation-iteration-count: 1;
        overflow: hidden;
    }
    @keyframes light {
        0% {
            margin-top: -44vw;
        }
        100% {
            margin-top: 0;
        }
    }
    .img-wrraper {
        width: 23.8vw;
        transform: scaleX(-1);
}
    .lighting-animation {
        animation: light_left 1.8s 0s 1;
    }
    @keyframes light_left {
        0% {
            margin-left: -19vw;
            margin-top: -19vh;
        }
        100% {
            margin-left: 0vw;
            margin-top: 0;
        }
    }
    .img-wrraper:nth-child(2) {
        width: 24vw;
        margin-right: 1vw;
        /* opacity: 0.5; */
    }
    .lighting-animation:nth-child(2) {
        animation: light_right 1.8s 0s 1;
    }
    @keyframes light_right {
        0% {
            margin-right: -19vw;
            margin-top: -19vh;
        }
        100% {
            margin-right: 0vw;
            margin-top: 0;
        }
    }
    .slider::-webkit-scrollbar {
        display: none;
    }
    .slider {
        scroll-behavior: smooth;
    }
    .slider-img {
        width: 13.994vw;
        height: 10.448vw;
        border-radius: 0.24vw;
        overflow: hidden;
        margin: auto;
        object-fit: cover;
    }
    .data-part {
        width: 12vw;
        margin: auto;
        text-align: center;
        font-size: 1vw !important;
    }
    .data-part p:nth-child(2) {
        font-size: 0.7vw;
    }
    .data-part p:nth-child(3) {
        font-size: 0.7vw;
    }
    .arrowpostion {
        width: fit-content;
        background-color: black;
        border-radius: 50px;
        padding: 5px;
        cursor: pointer;
        font-size: 0.8vw;
    }
    .logo-wrraper {
        width: 10vw;
        margin-left: auto;
        cursor: pointer;
    }
    .menu ul li {
        margin: 0vw 1.5vw 0vw 1.5vw;
        cursor: pointer;
    }
    .head_text h4 {
        font-size: 2.646vw;
        background: linear-gradient(90deg, #1a2980 0%, #26d0ce 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .head_text2 {
        font-size: 1.323vw;
        background: linear-gradient(90deg, #005c97 0%, #363795 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .btn2 {
        border: 0;
        border-radius: 50vw;
        font-size: 0.926vw;
        font-weight: 500;
    }
    .btn2:nth-child(1) {
        background-color: #3c74c0;
        color: white;
        width: 13.228vw;
        height: 3.638vw;
        padding-top: 1.117vw;
    }
    .btn2:nth-child(2) {
        background-color: white;
        color: #3c74c0;
        border: 1px #3c74c0 solid;
        padding: 0.2vw 3vw 0.2vw 3vw;
    }
    .btn2:nth-child(1):hover {
        background-color: #f7e05f;
        color: #3c74c0;
        transition-duration: 0.3s;
        width: 13.228vw;
        height: 3.638vw;
    }
    .btn2:nth-child(2):hover {
        background-color: #f7e05f;
        border: 1px solid #f7e05f;
        color: #3c74c0;
        transition-duration: 0.3s;
    }
    .circle {
        background-color: #7cc1ff;
        height: 1.19vw;
        width: 1.19vw;
        border-radius: 1vw;
        margin-top: 0.7vw;
    }
    .btn-mbl-sidebar {
        border: 0;
        padding: 1vw 3vw 1vw 3vw;
        border-radius: 50vw;
        font-size: 3.271vw;
        background-color: #3c74c0;
        color: white;
        position: absolute;
        bottom: 12.570vw;
    }
    .menu-back-style {
        background-color: #eeeff196;
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 100vw;
        z-index: 3;
        top: 0vw;
    }
    .logo-img {
        width: 28vw;
    }
    .main-div {
        justify-content: space-between;
        display: flex;
        align-items: center;
        padding: 3vw;
        background-color: white;
        position: fixed;
        width: 100vw;
        height: 18.692vw;
        z-index: 1;
        box-shadow: inset 0px 10px 8px -12px #ccc,
            inset 0px -10px 8px -12px #ccc;
    }
    .menu-section {
        position: fixed;
        height: 100vh;
        width: 67.056vw;
        background-color: #ffffff;
        z-index: 2147483855;
        right: 0vw;
        cursor: pointer;
        left: 100vw;
        top: 0vw;
    }
    .head-mbl {
        justify-content: start;
        display: flex;
        margin-top: 3vw;
        cursor: pointer;
        position: relative;
    }
    .h-clr {
        color: #3c74c0;
        margin-right: 6vw;
        font-size: 3.738vw;
        margin-top: 1.5vw;
        font-weight: bolder;
    }
    .hr-css {
        width: 59.112vw;
        margin-top: 6.776vw;
        margin-left: 5.972vw;
    }
    .hr {
        color: #c4c4c4;
        opacity: 1;
        height: 2px;
        width: 90%;
    }
    .list {
        margin-top: 10vw;
    }
    .list ul {
        list-style-type: none;
        padding-left: 0;
    }
    .head-logo {
        margin-right: 5vw;
    }
    .logo-sidebar {
        width: 40vw;
        margin-left: auto;
        margin-right: auto;
        margin-top: 6vw;
    }
    .mobile {
        padding: 0;
    }
    .head-text-mbl {
        width: 89.72vw;
        margin: 11vw auto 0 auto;
    }
    .name-text {
        font-weight: bold;
    }
    .text {
        width: 100%;
        position: absolute;
        top: 23vw;
    }
    .head-text2-mbl {
        width: 56.776vw;
        margin-top: 5.607vw;
        margin-left: 21.495vw;
    }
    .head-text-mbl h4 {
        background: linear-gradient(90deg, #1a2980 0%, #26d0ce 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-size: 7.009vw;
        word-spacing: 0.1vw;
        text-align: center;
        line-height: 8.484vw;
        font-weight: bold;
    }
    .img-warraper-mbl img {
        border-radius: 2.5vw;
        width: 28.159vw;
    }
    .head-text2-mbl h6 {
        text-align: center;
        background: linear-gradient(90deg, #005c97 0%, #363795 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-size: 3.271vw;
        line-height: 3.958vw;
    }
    .btn1-mbl {
        padding: 1vw 8vw 1vw 8vw;
        border-radius: 50vw;
        font-size: 2.336vw;
        background-color: white;
        color: #3c74c0;
        border: 1px #3c74c0 solid;
    }
    .btn-css {
        margin-top: 7.5vw;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .btn2-mbl {
        border: 0;
        margin-top: 1.869vw;
        height: 9.346vw;
        width: 32.477vw;
        border-radius: 50vw;
        font-size: 2.336vw;
        background-color: #3c74c0;
        color: white;
    }
    .btn3-mbl{
        justify-content: center;
        display: flex; 
        align-items: center;
        gap: 1vw;
        border: 0.15vw solid #3c74c0;
        margin-top: 1.869vw;
        height: 9.346vw;
        width: 32.477vw;
        border-radius: 50vw;
        font-size: 2.336vw;
        background-color: white;
        color: #3c74c0;
    }
    .back-img {
        overflow: hidden;
        display: flex;
        justify-content: space-between;
    }
    .back-img-mbl-left {
        width: 40.654vw;
        margin-left: -12.3vw;
        margin-top: 25vw;
    }
    .back-img-mbl-right {
        width: 40.654vw;
        margin-right: -13vw;
        margin-top: 25vw;
    }
    .slider-mbl {
        scroll-behavior: smooth;
        display: flex;
        justify-content: space-between;
        overflow: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;
        margin: 17.056vw 0 15vw 0;
        padding: 5vw 0;
        background-color: rgba(245, 251, 255, 1);
    }
    .slider-mbl::-webkit-scrollbar {
        display: none;
    }
    .desktop {
        display: block;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .mobile {
            display: block;
        }
        .light_animate {
            display: none !important;
        }
        .img-warraper-mbl {
            margin-left: 3vw;
        }
        .sli-mbl {
            border-radius: 1vw;
            margin-left: 3.346vw;
        }
        .data-part-mbl {
            width: 34.168vw;
            margin: auto;
            text-align: center;
            font-size: 3.271vw !important;
            margin-top: 4.673vw;
        }
        .data-part-mbl p:nth-child(2) {
            font-size: 2.336vw;
        }
        .data-part-mbl p:nth-child(3) {
            font-size: 2.336vw;
        }
    }
</style>
